/**
 * @generated SignedSource<<009d688ee421227851657193fccb3fad>>
 * @relayHash 8e5023cb91b8eef205bcec5c3403edfd
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID fd83c5fd208f37aebb9f955d0a717b8336ee9eb6d531edfc7d16c8bee023aee8

import type { ConcreteRequest, Query } from 'relay-runtime';
export type ConfluenceContentAccessRequestStatus = "APPROVE" | "DENY" | "PENDING" | "PENDING_SITE_APPROVAL" | "%future added value";
export type ResourceAccessType = "EDIT" | "VIEW" | "%future added value";
export type useAccessRequestsQuery$variables = {
  after?: string | null | undefined;
  cloudId: string;
  contentId: string;
  first?: number | null | undefined;
  status?: ConfluenceContentAccessRequestStatus | null | undefined;
};
export type useAccessRequestsQuery$data = {
  readonly confluence_contentAccessRequestByStatus: {
    readonly nodes: ReadonlyArray<{
      readonly accessRequestedAaid: string;
      readonly id: string;
      readonly requestAccessType: ResourceAccessType;
      readonly status: ConfluenceContentAccessRequestStatus;
      readonly user: {
        readonly displayName: string | null | undefined;
        readonly emails: ReadonlyArray<{
          readonly isPrimary: boolean | null | undefined;
          readonly value: string | null | undefined;
        } | null | undefined> | null | undefined;
        readonly photos: ReadonlyArray<{
          readonly isPrimary: boolean | null | undefined;
          readonly value: string | null | undefined;
        } | null | undefined> | null | undefined;
      } | null | undefined;
    } | null | undefined>;
    readonly pageInfo: {
      readonly __typename: "PageInfo";
      readonly endCursor: string | null | undefined;
      readonly hasNextPage: boolean;
      readonly startCursor: string | null | undefined;
    };
  } | null | undefined;
};
export type useAccessRequestsQuery = {
  response: useAccessRequestsQuery$data;
  variables: useAccessRequestsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "after"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  },
  {
    "defaultValue": 10,
    "kind": "LocalArgument",
    "name": "first"
  },
  {
    "defaultValue": "PENDING",
    "kind": "LocalArgument",
    "name": "status"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "kind": "Variable",
    "name": "contentId",
    "variableName": "contentId"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "status",
    "variableName": "status"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v3 = [
  {
    "kind": "ScalarField",
    "name": "isPrimary"
  },
  {
    "kind": "ScalarField",
    "name": "value"
  }
],
v4 = {
  "concreteType": "AtlassianUserEmail",
  "kind": "LinkedField",
  "name": "emails",
  "plural": true,
  "selections": (v3/*: any*/)
},
v5 = {
  "concreteType": "AtlassianUserPhoto",
  "kind": "LinkedField",
  "name": "photos",
  "plural": true,
  "selections": (v3/*: any*/)
},
v6 = {
  "kind": "ScalarField",
  "name": "accessRequestedAaid"
},
v7 = {
  "kind": "ScalarField",
  "name": "requestAccessType"
},
v8 = {
  "kind": "ScalarField",
  "name": "status"
},
v9 = {
  "kind": "ScalarField",
  "name": "id"
},
v10 = {
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "endCursor"
    },
    {
      "kind": "ScalarField",
      "name": "hasNextPage"
    },
    {
      "kind": "ScalarField",
      "name": "startCursor"
    },
    {
      "kind": "ScalarField",
      "name": "__typename"
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useAccessRequestsQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "ConfluenceContentAccessRequestConnection",
        "kind": "LinkedField",
        "name": "confluence_contentAccessRequestByStatus",
        "plural": false,
        "selections": [
          {
            "concreteType": "ConfluenceContentAccessRequest",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              {
                "concreteType": "AtlassianUser",
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/)
                ]
              },
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/)
            ]
          },
          (v10/*: any*/)
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useAccessRequestsQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "ConfluenceContentAccessRequestConnection",
        "kind": "LinkedField",
        "name": "confluence_contentAccessRequestByStatus",
        "plural": false,
        "selections": [
          {
            "concreteType": "ConfluenceContentAccessRequest",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              {
                "concreteType": "AtlassianUser",
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v9/*: any*/)
                ]
              },
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/)
            ]
          },
          (v10/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "cacheID": "8e5023cb91b8eef205bcec5c3403edfd",
    "id": "fd83c5fd208f37aebb9f955d0a717b8336ee9eb6d531edfc7d16c8bee023aee8",
    "metadata": {},
    "name": "useAccessRequestsQuery",
    "operationKind": "query",
    "text": "query useAccessRequestsQuery($after:String,$cloudId:ID!,$contentId:ID!,$first:Int=10,$status:ConfluenceContentAccessRequestStatus=PENDING){confluence_contentAccessRequestByStatus(after:$after,cloudId:$cloudId,contentId:$contentId,first:$first,status:$status){nodes{user{displayName,emails{isPrimary,value},photos{isPrimary,value},id},accessRequestedAaid,requestAccessType,status,id},pageInfo{endCursor,hasNextPage,startCursor,__typename}}}"
  }
};
})();

(node as any).hash = "c643f30357ca28434b368455d68cf516";

export default node;
